
import Home from './pages/Home';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Dashboard from './pages/admin/Dashboard';
import Projects from './pages/Projects';
import Download from './pages/Download';
import Features from './pages/Features';
import About from './pages/About';
import AlkebulanGame from './components/AlkebulanGame';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


const App = () => {
  console.log('App component rendering');
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LogWrapper name="Home"><Home /></LogWrapper>} />
        <Route path="/contact" element={<LogWrapper name="Contact"><Contact /></LogWrapper>} />
        <Route path="/projects" element={<LogWrapper name="Projects"><Projects /></LogWrapper>} />
        <Route path="/download" element={<LogWrapper name="Download"><Download /></LogWrapper>} />
        <Route path="/admin" element={<LogWrapper name="Admin"><Admin /></LogWrapper>} />
        <Route path="/admin/dashboard" element={<LogWrapper name="Dashboard"><Dashboard /></LogWrapper>} />
        <Route path="/features" element={<LogWrapper name="Features"><Features /></LogWrapper>} />
        <Route path="/donate" element={<LogWrapper name="Projects (Donate)"><Projects /></LogWrapper>} />
        <Route path="/about" element={<LogWrapper name="About"><About /></LogWrapper>} />
        <Route path="/alkebulan" element={<LogWrapper name="Alkebulan"><AlkebulanGame /></LogWrapper>} />
      </Routes>
    </BrowserRouter>
  );
};

const LogWrapper = ({ name, children }: { name: string; children: React.ReactNode }) => {
  console.log(`Rendering route: ${name}`);
  return <>{children}</>;
};

export default App;
